import React, { useEffect, useState } from 'react';
import { TETROMINOS } from '../tetrominos';

interface GhostCellProps {
  type?: string;
}

// A semi-transparent preview cell showing where the tetromino will land
const GhostCell: React.FC<GhostCellProps> = ({ type = '' }) => {
  const [pulseState, setPulseState] = useState(0);
  
  // Get base color from tetromino type or default to white
  const baseColor = typeof type === 'string' && TETROMINOS[type]
    ? TETROMINOS[type].color
    : '255, 255, 255';
  
  // Pulse animation effect
  useEffect(() => {
    const pulse = setInterval(() => {
      setPulseState(prev => (prev + 1) % 100);
    }, 50);
    
    return () => clearInterval(pulse);
  }, []);
  
  // Calculate pulsing opacity between 0.3 and 0.7
  const opacity = 0.3 + (Math.sin(pulseState / 15) + 1) / 5;
  
  const style: React.CSSProperties = {
    width: '100%',
    height: '100%',
    boxSizing: 'border-box',
    background: 'transparent',
    border: `2px dashed rgba(${baseColor}, ${opacity})`,
    boxShadow: `inset 0 0 8px rgba(${baseColor}, ${opacity / 2})`,
    animation: 'ghostPulse 1.5s ease-in-out infinite',
  };
  
  return <div style={style} />;
};

export default React.memo(GhostCell);